import Block from "base/Block";
import Inputmask from "inputmask";

class Form extends Block {
	static get blockName() {
		return 'b-form';
	}

	onInit() {
		const formName = this.el.getAttribute('name');
		const container = this.el.querySelector(`.${this.blockName}__input-check-container`);
		if (container) {
			const acceptAll = container.querySelector(`.${this.blockName}__input-checkbox--all input[type="checkbox"]`);
			const slaveCheckbox = container.querySelectorAll(`.${this.blockName}__input-checkbox:not(.${this.blockName}__input-checkbox--all) input[type="checkbox"]`);

			if (acceptAll && slaveCheckbox.length > 0) {
				//если клин на принять все
				acceptAll.addEventListener('change', (e) => {
					const isChecked = e.target.checked;
					slaveCheckbox.forEach((el) => {
						el.checked = isChecked;
						el.dispatchEvent(new Event('change'));
					})
				})

				//меняем состояние инпута принять все в зависиости от дочерних
				slaveCheckbox.forEach((el) => {
					el.addEventListener('change', () => {
						const allChecked = Array.from(slaveCheckbox).every((e) => e.checked);
						acceptAll.checked = allChecked;
					})
				})
			}
		}

		let im = new Inputmask('+7-999-999-99-99');
		im.mask(this.el.querySelector(`.${this.blockName}__phone`));

		if(formName == 'appeals') {
			this.fillFieldsAppealForm();
		}
	}

	fillFieldsAppealForm() {
		const btnList = document.querySelectorAll('.js-modal-link[href="#appeals-form"]');
		if(btnList.length) {
			btnList.forEach(btn => {
				btn.addEventListener('click', () => {
					const inputDoctor = this.el.querySelector('input#doctor');
					const dativeName = btn.dataset.doctorDative;
					inputDoctor.value = btn.dataset.doctor;

					if(dativeName) {
						const parts = dativeName.split(' ');
						const html = `<span class="blue">${parts[0]}</span> ${[parts[1], parts[2]].join(" ")}`;
						this.el.closest('.appeals-form').querySelector('.modal-title > span').innerHTML = html;
					} else {
						this.el.closest('.appeals-form').querySelector('.modal-title > span').innerHTML = "";
					}
				});
			});
		}
	}
}

Block.register(Form);
export default Form;